import customTheme from '~/styles/theme';

import { Color } from '../types/color';

export const CHART_COLORS: Color = {
  0: customTheme.colors.tertiary[500],
  1: customTheme.colors.secondary[500],
  2: customTheme.colors.primary[500],
  3: customTheme.colors.neutral[200],
} as const;

export const EMPTY_CHART_COLOR: Color = { 0: customTheme.colors.neutral[200] };

export const AGE_RANGES = ['18-24', '25-34', '35+'];
